/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import {
  Alert,
  Badge,
  Button,
  ContextMenu,
  FormattedComposite,
  IconClickable,
} from '@cochlear-design-system/foundation';

import { getDisplayFormat } from '../utils/getDisplayFormat';

const badgeMatchMap = ['Billing', 'Mailing', 'Shipping'];
export const AddressMaintenanceListView = (props) => {
  const { config: listConfig, data, labels } = props;

  let orderedData = [];
  const cloneData = _.cloneDeep(data);
  cloneData?.map((item, index) => {
    item.count = 0;
    badgeMatchMap.map((badgeItem) => {
      if (item[`is${badgeItem}`]) {
        item.count++;
      }
    });
  });

  // cloneDataOriginal originalData for the state stored
  const cloneDataOriginal = _.cloneDeep(data);
  cloneDataOriginal?.map((item, index) => {
    item.count = 0;
    badgeMatchMap.map((badgeItem) => {
      if (item[`is${badgeItem}`]) {
        item.count++;
      }
    });
  });

  // orderedData for the state display
  orderedData = _.orderBy(cloneData, ['count'], 'desc');
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <>
      <div
        className={classNames(
          listConfig.className,
          orderedData && orderedData.length === 0 ? `is-empty` : '',
          'ccl-address-list-view',
        )}
      >
        {listConfig.hideActionBar ? null : (
          <div
            data-nw-state="read"
            className="ccl-e-detail-action-bar"
          >
            <div className="ccl-e-detail-action-bar__title">
              <span>
                {orderedData.length > 1
                  ? labels['labels.addressList.addressList']
                  : labels['labels.addressList.address']}
              </span>
            </div>
            <div className="ccl-e-detail-action-bar__action">
              {listConfig?.showAdd &&
                (listConfig?.showAddButton ? (
                  <Button
                    onClick={listConfig.onAdd}
                    icon="add"
                    iconPosition="leading"
                    size="small"
                    text={labels['labels.addressList.add']}
                    variant="brand-primary"
                  />
                ) : (
                  <IconClickable
                    handleClick={listConfig.onAdd}
                    leftIcon={{
                      size: 'sm',
                      disabled: false,
                      type: 'add',
                    }}
                    text={labels['labels.en.addressList.add']}
                    clkContainerCssModifier="details-bar"
                    lblContainerCssModifier="inline"
                  />
                ))}
            </div>
          </div>
        )}

        {/* alertComponent is used for the alert message post submit and is optional */}
        {listConfig?.alertComponent && (
          <Alert
            show={listConfig?.alertComponent?.show}
            variant={listConfig?.alertComponent?.variant}
            dismissible={listConfig?.alertComponent?.dismissible}
            onClose={listConfig?.alertComponent?.onClose}
            closeLabel={listConfig?.alertComponent?.closeLabel}
          >
            {listConfig?.alertComponent?.content}
          </Alert>
        )}

        <>
          {orderedData.length === 0 && (
            <div className="ccl-address-list-item is-empty">
              {labels['labels.address.read.emptyList'] || '--'}
            </div>
          )}
          {orderedData.length > 0 &&
            orderedData?.map((item, index) => (
              <div className="ccl-address-list-item" key={index}>
                <FormattedComposite
                  config={{
                    format: getDisplayFormat(
                      listConfig?.country?.code,
                    ).singleLineFormat,
                    type: 'composite',
                  }}
                  data={item?.value?.address}
                />

                <div className="ccl-address-list-item-badges">
                  <div className="ccl-address-list-item-badges--box">
                    {badgeMatchMap.map(
                      (badgeItem, badgeIndex) =>
                        item[`is${badgeItem}`] && (
                          <Badge
                            key={`badgeItem-${index}-${badgeIndex}`}
                          >
                            {
                              labels[
                                `labels.addressList.${badgeItem.toLowerCase()}`
                              ]
                            }
                          </Badge>
                        ),
                    )}
                  </div>
                </div>

                {listConfig.mode !== 'readOnly' &&
                  listConfig.contextMenu && (
                    <ContextMenu
                      id={`context-menu-${index}`}
                      icon="more-vert"
                      size={listConfig.contextMenuSize || 'small'}
                      isMultipleSelect
                      openMenu={openMenu}
                      setOpenMenu={setOpenMenu}
                      items={listConfig.contextMenu.map(
                        (contextItem) => {
                          return {
                            text: contextItem.text,
                            icon: contextItem.icon,
                            onclick: () => {
                              contextItem.onclick(item, index);
                            },
                          };
                        },
                      )}
                    />
                  )}
              </div>
            ))}
        </>
      </div>
    </>
  );
};
